<template>
  <div>
    <el-dialog title="卡片短信" custom-class="" :visible.sync="visible"  :before-close="handleClose" 
    :width="isMediaQualification?'1150px':'800px'">
      <div>
        <div class="sms-content"  :style="{ 'margin-bottom':isMediaQualification ? '190px' : '' }">
          <section class="main">
            <el-form ref="formSearch" class="sms-box" :modle="formData" :disabled="isReadOnly" label-width="120px">
              <el-form-item required label="节点名称" style="position: relative;">
                <div class="name-wrap">
                  <el-input class="name-wrap-input" v-model="formData.name" show-word-limit maxlength="50"></el-input>
                  <div class="name-wrap-setName" @click="setName">智能命名</div>
                </div>
              </el-form-item>
              <el-form-item required label="卡片短信模板" v-loading="editLoading">
                <!-- <div v-if="isMediaQualification"> -->
                  <div v-if="isMediaQualification" class="fx_btn">
                    <el-select v-model="mediaTemplateId" @change="changeCard"  filterable >
                      <el-option v-for="(item, index) in cardOptionList" :key="index" :value="item.mediaTemplateId"
                        :label="item.name"></el-option>
                    </el-select>
                    <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addCardModule">添加模板</span>
                  </div>
                  <div v-else>
                  <div class="notShow">
                    <img src="@/assets/images/未开通富信.png" alt="">
                    <p>您还未开通卡片短信营销功能</p>
                    <div class="bottom-btn">
                      <button class="keep" style="width: 150px;" @click.prevent="toSubmit">
                        去提交资质申请开通
                      </button>
                    </div>
                  </div>
                  <sms-info-template v-if="smsInfoTemplateShow" @close="handleCloseSmsInfo1" :isShow="smsInfoTemplateShow" />
                </div>
                <!-- </div> -->
              </el-form-item>

              <div v-if="isMediaQualification">
                <el-form-item label="回落类型:">
                  <el-radio-group v-model="failBackConfig.failBackType">
                    <el-radio :label="0">不回落</el-radio>
                    <el-radio :label="1">回落普通短信</el-radio>
                    <el-radio :label="2">回落富信</el-radio>
                  </el-radio-group>
                  <span style="margin-left: 8px; font-size: 14px; cursor: pointer;color: #7f85e9" >
                    回落说明
                    <el-tooltip 
                      class="item"
                      effect="light"
                      placement="top-start">
                      <div slot="content">
                        温馨提示：<br />
                        由于卡片短信目前只支持全部华为机型和部分的小米机型，其他类型收集无法接收卡片短信<br/>
                        所以建议设置回落短信，设置后指定机型收到的短信为卡片短信，其他手机收到的均为普通短信。
                      </div>
                      <span class="question_icon">!</span>
                    </el-tooltip>
                  </span>
                </el-form-item>
                <el-form-item label="编辑短信:" v-if="failBackConfig.failBackType == 1">
                  <div class="textarea">
                    <el-input class="textareaChange" type="textarea" :rows="5" placeholder="请输入内容" v-model="failBackConfig.content" @paste.native="shopLinkCheck($event, insertCoupon)">
                    </el-input>
                    <div class="footInfo">
                      <div>
                        <button class="select" @click.prevent="templateShow = true">
                          选择模板
                        </button>
                        <button class="keep" @click.prevent="handleShowModule">
                          保存模板
                        </button>
                        <span>已输入
                          <span style="color: #fe4d45">{{ failBackConfig.content.length + (suffixList[0] ? suffixList[0].length : 0) + 8
                          }}</span>
                          个字（含签名及退订文字），预计
                          {{ Math.ceil(sendFailInfoLength > 70 ? sendFailInfoLength / 67 : sendFailInfoLength / 70) }}
                          条短信
                        </span>
                      </div>
                      <div class="ask-content">
                        <span style="
                                font-weight: normal;
                                margin-left: 8px;
                                color: #7f85e9;
                              ">计费规则</span>
                        <el-tooltip class="item" effect="light" placement="top-start" style="color:#999;">
                          <div v-html="content1" slot="content"></div>
                          <span class="question_icon" style="margin-left: 4px">?</span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="footTips" style="height: 200px; position: relative">
                    <img src="@/assets/images/new_icon_waring_yellow.png" style="
                            display: inline-block;
                            float: left;
                            position: absolute;
                            width: 14px;
                            height: 14px;
                            color: #ffffff;
                            margin: 0px 4px 0 0;
                            top: 9px;
                          " />
                    <span style="margin-left: 22px; line-height: 21px">
                      (1) 短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链;
                      <br />
                      (2) 生成短链后建议复制到手机浏览器打开确保短链接能正常打开。
                      <br />
                      (3) 包含跳转链接的短信内容需满足以下填写规范：动词+页面名+链接 (示例：点击加购x商品详情页> 3.cn/1l-dAxxx)
                      <br/> 
                      (4) 短网址点击数据由官方返回，部分链接（如含中间页跳转，非原始链接）官方不支持埋点，因此无短网址点击数据
                      <br/>
                      (5) 原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
                    </span>
                  </div>
                </el-form-item>
                <el-form-item label="辅助工具:" v-if="failBackConfig.failBackType == 1">
                  <div class="tool">
                    <p @click.prevent="insertShortUrlShow = true"><i class="iconfont iconbtn_duanwangzhi"></i>插入短网址</p>
                  </div>
                </el-form-item>
                <el-form-item label="富信模板:" v-if="failBackConfig.failBackType == 2">
                  <el-select v-model="failBackConfig.mediaTemplateId" @change="changeFailMedia"  filterable>
                      <el-option v-for="(item, index) in mediaOptionList" :key="index" :value="item.mediaTemplateId"
                        :label="item.name"></el-option>
                    </el-select>
                    <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="addMediaModule">添加模板</span>
                </el-form-item>
                <el-form-item label="短信签名">
                  <div class="btnList">
                    <div class="btnBox" v-for="(item, index) in suffixList" :key="'label' + index"
                      @click.prevent="switchSuffix(index)" style="margin-bottom:5px">
                      <button class="btn">{{ item }}</button>
                      <span class="check" v-if="formData.jdSmsSuffix === item">
                        <i class="el-icon-check"></i>
                      </span>
                    </div>
                    <span style="font-size: 14px; cursor: pointer" class="btnListButtom" @click="replaceSignature">更换</span>
                  </div>
                </el-form-item>
                <el-form-item label="过滤设置:">
                  <el-checkbox :label="true" v-model="formData.filtrationBlacklistFlag">
                    过滤黑名单人群
                    <span @click.stop="toBlack" style="color: #7f85e9; margin-left: 8px">设置黑名单</span>
                  </el-checkbox>
                  <el-checkbox :label="true" v-if="isPremissionShow" v-model="formData.filterAlreadySentFlag">
                    <span>屏蔽近</span>
                    <el-input v-model.number="formData.filterDays" @keyup.native="limitInput($event)"
                      onblur="value=value.replace(/[^\d]/g,'')" style="width: 100px; padding: 0 6px">
                    </el-input>
                    <span>天已发送客户</span>
                  </el-checkbox>
                </el-form-item>
              <!-- 添加发送限制人数  v-if="sendType == '1'"-->
              <el-form-item label="发送人数:" >
              <div>
                <el-radio-group v-model="formData.sendIntType" @change="handleSendType">
                  <el-radio :label="0">不限</el-radio>
                  <el-radio :label="1">限制发送数</el-radio>
                </el-radio-group>
                <el-input v-model="formData.smsLimit" placeholder="填写发送数" style="width: 120px; margin-left: 8px"
                  :disabled="formData.sendIntType === 0" @keyup.native="
                    formData.smsLimit = oninput(formData.smsLimit)
                  " @change="sendPeopleChange"></el-input>
               </div>
             </el-form-item>
             <!-- end -->
                <el-form-item label="短信测试:" class="smsTest">
                  <div class="test">
                    <!-- 需开启富信测试后才可选择测试手机号 -->
                    <el-select v-model="mediaTestMobilesList" multiple collapse-tags placeholder="请选择"
                      style="width: 264px;vertical-align: top;" @change="selectMediaTestMobiles" >
                      <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                    <el-button style="margin-left: 8px;" class="record1" @click="sendRichTest">发送测试短信</el-button>
                    <el-button class="record" style="margin-right: 0px;" @click="smsDialogs = true">短信记录</el-button>
                    <span style="margin-left: 8px; font-size: 14px; cursor: pointer" class="btnListButtom" @click="updataPhone">修改测试手机号</span>
                  </div>
                  <div class="info">
                    <i class="el-icon-warning warning-icon"></i>
                    <p>注：短信测试号码为申请签名时报备的号码,且发送测试短信不受频控限制。</p>
                    
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </section>
        </div>
        <div class="xiao-hug xiao_hug2" v-if="isMediaQualification">
          <div>
            <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">  
              <sms-info-card-body v-if="mediaTemplateId && preCardShow" :key="mediaTemplateId" :id="mediaTemplateId"></sms-info-card-body>
            </div>
            <div class="mobile-tips">卡片短信预览效果</div>
          </div>
        </div>
        <div class="dialog-footer-btn" v-if="isMediaQualification">
          <el-button class="reset" @click="handleClose">取消</el-button>
          <el-button class="search" v-loading="updateLoading" :disabled="updateLoading || isReadOnly"
            @click="handleConfirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 插入短链接 -->
    <insert-short-dialog v-if="insertShortUrlShow" :typeSms="2" :zIndex="'4000'"
      @close="insertUrlChange"></insert-short-dialog>
    <!-- 选择模板 -->
    <sms-template v-if="templateShow" :isShow="templateShow" @close="templateChange"></sms-template>

    <!-- 保存模板 -->
    <my-popup title="保存模板" width="370" zIndex="3330" :flag="keepTmpShow" @close="keepTmpChange">
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select v-model="keepTmpValue" placeholder="请选择" style="width: 240px">
            <el-option v-for="(item, index) in dirList" :key="index" :label="item.title" :value="item.tid"></el-option>
            <!-- <el-option label="云短信旗舰店专用" :value="1"></el-option>
            <el-option label="太阳短信旗舰店专用" :value="2"></el-option>
            <el-option label="月亮短信旗舰店专用" :value="3"></el-option>-->
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>
    <!-- 短信内容预览 -->
    <sms-info v-if="smsInfoShow" @close="handleCloseSmsInfo" :isShow="smsInfoShow" :id="smsInfoRowData.contentId"
      :title="smsInfoRowData.title" :text="smsInfoRowData.text" />
    <!-- 短信记录 -->
    <sms-template2 :smsDialog="smsDialogs" v-if="smsDialogs" :isCard="true" @transferName="transferName"
      @close="smsDialogClose"></sms-template2>
    <!-- 修改号码弹窗 -->
    <el-dialog title="修改测试短信号码" :visible.sync="showDialogOne" width="460px" style="min-width: 1100px">
      <template slot="title">
        <span>修改测试短信号码</span>
      </template>
      <div class="dialog-wrapper">
        <!-- <div class="item">
          <span class="item-title">短信测试：</span>
          <el-input size="small" class="input" v-model="testMobiles"></el-input>
        </div> -->
        <div class="remarks">
          <div>请前往【京东云舟】-【工具】-【短信工具】-【短信签名】中进行修改号码中操作</div>
          <!-- 注：填写测试号码，在测试发送时无需审核短信内容。 -->
          <!-- <div>1、测试短信手机号不受频控限制，最多填写15个，多个之间用英文逗号分隔；</div>
          <div>2、修改完成后立即生效，且测试手机号的修改会应用到全部渠道；</div>
          <div>3、每天修改手机号的次数上限为5次；</div> -->
        </div>
        <div></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button showDialog="showDialog" style="width: 96px" @click="showDialogOne = false">关闭</el-button>
        <!-- <el-button showDialog="showDialog" style="width: 96px" @click="showDialogOne = false">取消</el-button>
        <el-button @click="mobilPhoneSubmit" type="primary" style="width: 96px">提交</el-button> -->
      </span>
    </el-dialog>
    <sendTestCardConfirm 
      v-if="sendTestMediaConfirmShow"
      @close="sendTestMediaConfirmShow = false" 
      @confirm="sendTestMediaConfirmShow = false"
      :source="3"
      :mediaTestMobilesList="mediaTestMobilesList"
      :title="cardName"
      :mediaTemplateId="mediaTemplateId">
    </sendTestCardConfirm>
  </div>
</template>
  
<script>

import mnode from "@/api/intelligentMarket/a_node";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { getValidSmsTestMobiles,getMediaList,getCardList } from "@/api/smsSend";
import { getTemplateDir, createTemplate, getSmsMediaTemplate, getSmsMediaTemplateDetail, smsMediaTemplateSave } from "@/api/smsTemplates";
import { updateSuffixMobileById } from "@/api/backstage/messageBill";
import sendTestCardConfirm from '@/components/sendTestCardConfirm';
import { getSeller } from "@/api/richSms";
// 短信记录模板
import smsTemplate2 from "@/components/sms-templates-x-drawer.vue";
import smsInfo from "@/components/sms-info";
import smsInfoTemplate from "@/components/sms-info-template";
import myPopup from "@/components/myPopup";
import smsInfoCardBody from "@/components/sms-info-card-body";
import smsTemplate from "@/views/serviceCenter/sms_template";
import insertShortDialog from "@/components/insert-short-dialog";

export default {
  name: "",
  data() {
    return {
      
      insertShortUrlShow:false,
      // 保存模板状态控制 ---- 内容
      keepTmpShow: false,
      keepTmpValue: "",
      dirList: [],
      templateShow:false,
      cardName:'',
      failBackConfig:{
        failBackType:0,
        content:'',
        jdShortLink:'',
        realUrl:'',
        mediaTemplateId:'',
        mediaMulitiFileId:'',
      },
      editLoading: true,
      mobileScreen: require("@/assets/images/mobileScreen.png"),
      preCardShow:false,
      smsInfoTemplateShow:false,
      sendTestMediaConfirmShow:false,
      isMediaQualification:false,
      mediaId2:null,
      mediaTemplateId:null,
      cardOptionList:[],
      mediaOptionList:[],
      isPremissionShow: false, // 屏蔽近X天发送客户的权限
      formData: {
        nodeId: "",
        name: "",
        content: "",
        jdSmsSuffix: "",
        jdShortLink: "",
        realUrl: '',
        filtrationBlacklistFlag: false,
        filterAlreadySentFlag: false,
        filterDays: '',
        mediaTestMobiles: '',
        sendIntType:0,
        smsLimit:''
      },
      TTip: '拒收请回复R',
      suffixList: [],
      updateLoading: false,
      smsDialogs: false,
      richMessageData: {}, // 富信数据
      testOptions: [], // 获取测试手机号
      textPhoneId: '', // 修改测试手机号id
      mediaTestMobilesList: [], // 选中的测试手机号列表
      showDialogOne: false, // 修改测试手机号弹窗
      mobilPhone: '', // 测试手机号
      testMobiles: '', // 修改测试手机号
      selectTempleteShowDialog: false, // 富信选择模板
      richkeepTmpShow: false, // 富信保存模块弹窗
      smsInfoShow: false, // 短信预览弹窗
      smsInfoRowData: {}, // 短信详情数据
      selectTemplateData: [],// 选择模板
      mediaTemplateForm: {  // 富信选择模板列表查询
        size: 10,
        current: 1
      },
      templatePaginationInfo: {  // 选择模板分页器
        current: 1,
        size: 10,
        total: 2
      },

      tableLoading: false,
      mediaFlag: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    smsInfo,
    smsInfoTemplate,
    smsTemplate2,
    myPopup,
    sendTestCardConfirm,
    smsInfoCardBody,
    smsTemplate,
    insertShortDialog
  },
  mounted() {
    this.formData.nodeId = this.nodeId;
    this.getSuffixList();
    this.handleShowPremission();
    // 获取当前节点详情
    mnode
      .getNode({
        nodeId: this.nodeId,
      })
      .then((res) => {
        if (res.code == "1") {
          console.log(res.data);
          this.formData.name = res.data.name;
          
          var smsNode = res.data.smsNode;
          this.formData.content = smsNode.content;
          this.formData.filtrationBlacklistFlag = smsNode.filtrationBlacklistFlag ? true : false
          this.formData.filterAlreadySentFlag = smsNode.filterAlreadySentFlag ? true : false
          this.formData.filterDays = smsNode.filterDays
          if (smsNode.mediaTestMobiles) {
            this.mediaTestMobilesList = smsNode.mediaTestMobiles.split(',')
            this.formData.mediaTestMobiles = smsNode.mediaTestMobiles
          }else{
          }
          var failBackConfig = smsNode.failBackConfig
          this.failBackConfig.failBackType = failBackConfig.failBackType;
          this.failBackConfig.content = failBackConfig.content;
          this.failBackConfig.jdShortLink = failBackConfig.jdShortLink;
          this.failBackConfig.realUrl = failBackConfig.realUrl;
          this.failBackConfig.mediaTemplateId = failBackConfig.mediaTemplateId;
          this.failBackConfig.mediaMulitiFileId = failBackConfig.mediaMulitiFileId;
          this.mediaId2 = smsNode.mediaTemplateId
          if(smsNode.smsLimit){
           this.formData.sendIntType = 1
           this.formData.smsLimit = smsNode.smsLimit
          }else{
            this.formData.sendIntType = 0
            this.formData.smsLimit = '';
          }
        }
      });
    // 获取测试手机号
    getValidSmsTestMobiles().then(res => {
      if (res.code == 1) {
        this.testOptions = res.data.smsTestMobiles
        this.testMobiles = res.data.smsTestMobiles.join(',')
        this.textPhoneId = res.data.id
      }
    })
    getSeller().then(res => {
      this.editLoading = false;
      if (res.code == 1) {
        this.isMediaQualification = res.data.isMediaQualification
        if(this.isMediaQualification){
          this.getCardOption('');
          this.getMediaOption('');
        }
      }
    }).catch(res => {this.editLoading = false;});
    // this.getMediaOption('');
  },
  computed: {
    viewVisible: {
      get: function () {
        return this.visible
      },
      set: function (newValue) {
        if (newValue) {
          this.$emit('update:visible', true)
        } else {
          this.$emit('update:visible', false)
        }
      }
    },
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    sendFailInfoLength() {
      try {
        if (this.failBackConfig.content) {
          return this.failBackConfig.content.length + this.formData.jdSmsSuffix.length + 2 + this.TTip.length;
        } else {
          return 0;
        }
      } catch (e) {
        return 0;
      }
    },
    content1() {
      return (
        "<div>1.70个字计1条短信，超过70字按照67字每条计费。</div>" +
        "<div>2.一个汉字，字母或标点空格都算作一个字。</div>" +
        '<div>3.带标签短信以实际发送为准，有可能超过默认字数。</div>' +
        '<div>4."签名"与"拒收请回复R"包含在字数中。</div>' +
        '<div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>' +
        '<div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>'
      );
    },
  },
  watch: {
    permissions(nVal, oVal) {
      if (nVal.indexOf('hide:filter:send') != '-1') {
        // 显示屏蔽发送按钮
        this.isPremissionShow = true;
      }
    },
    'formData.smsType': {
      handler(nVal) {
        // console.log('短信类型',nVal);
        if (nVal == 0) {
          this.clearBuriedPoint()
        } else {
          // if (this.sendType == 2) {
            this.buriedPoint(2, '智能营销/卡片短信', "客户营销", "精准营销")
          // }
        }
      },
      immediate: true,
    }
  },
  methods: {
    insertUrlChange(val, obj) {
      this.insertShortUrlShow = false;
      if (!val) {
        return;
      }
      this.failBackConfig.content += " " + obj.shortLink + " ",
      this.failBackConfig.jdShortLink = obj.shortLink,
      this.failBackConfig.realUrl = obj.originUrl;
    },
    templateChange(val, item) {
      console.log("选择模板的返回==", val, item);
      // this.inputContent = item.content;
      if (val == true) {
          this.failBackConfig.content = item.content;
      }
      this.templateShow = false;
    },
     // 保存模板 显示
   async handleShowModule() {
      var param = {
        type: 0,
      };
     await getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.keepTmpShow = true;
          this.dirList = res.data;
        } 
      });
    },
    // 保存模板隐藏
    keepTmpChange(val) {
      this.keepTmpShow = false;
      // 保存
      if (val == 1) {
        var param = {
          tid: this.keepTmpValue,
          content: this.failBackConfig.content,
        };
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success({ message: "保存模板成功！", customClass: 'message-zindex' });
          } else {
            this.$message.error({ message: res.message, customClass: 'message-zindex' });
          }
        });
      }
    },
    // 查看富信营销案例
    checkOut() {
      this.smsInfoTemplateShow = true
    },
    // 关闭富信营销案例弹窗
    handleCloseSmsInfo1() {
      this.smsInfoTemplateShow = false
    },
    // 提交资质申请开通
    toSubmit() {
      // 跳转至  后台管理-富信资质
      this.$router.push({ name: 'media_qualification' })
    },
    addCardModule(){
      let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_module",
        query: { type: "6" },
      });
      window.open(routeUrl.href, "_blank");
    },
    addMediaModule(){
      let routeUrl = this.$router.resolve({
        path: "/backstage/backstage/sms_module",
        query: { type: "5" },
      });
      window.open(routeUrl.href, "_blank");
    },
    getCardOption(name){
      getCardList({name}).then(res=>{
        if(res.code == 1){
          this.cardOptionList = res.data
          if(this.mediaId2){
            // let row = this.cardOptionList.find(o=>o.id == this.mediaId2)
            this.mediaTemplateId = this.mediaId2
            this.changeCard();
          }
        }else{
          this.$message.error(res.message)
        }
      })
    },
    getMediaOption(name){
      getMediaList({name}).then(res=>{
        if(res.code == 1){
          this.mediaOptionList = res.data
        }else{
          this.$message.error(res.message)
        }
      })
    },
     // 富信测试
    sendRichTest(){
      if( !this.mediaTemplateId){
        this.$message.warning("请选择卡片短信模板");
        return;
      }
      if(this.failBackConfig.failBackType == 1 && !this.failBackConfig.content){
        this.$message.warning("请填写回落短信内容");
        return;
      }
      if(this.failBackConfig.failBackType == 2 && !this.failBackConfig.mediaTemplateId){
        this.$message.warning("请选择回落富信模板");
        return;
      }
      if(this.mediaTestMobilesList && this.mediaTestMobilesList.length > 0){
        this.sendTestMediaConfirmShow = true;
      }else{
        this.$message.warning('请输入正确的手机号！');
        return 
      }
    },
    changeCard(){
      let row = this.cardOptionList.find(o=>o.mediaTemplateId == this.mediaTemplateId)
      this.formData.content = row.text
      this.formData.mediaTitle = row.title
      this.cardName = row.title
      this.preCardShow = true;
    },
    // 不可输入小数
    oninput(val) {
      return val ? val.replace(/\D/g, "") : "";
    },
    // 发送限制数
    handleSendType(val) {
      this.formData.smsLimit = "";
    },
    // 发送人数的限制
    sendPeopleChange(val) {
      if (val == 0) {
        this.formData.smsLimit = "";
        this.$message.warning("人数只能输入正整数");
      } 
    },
    // 智能命名
    setName(){
      mnode.getAutoName(this.nodeId).then(res=>{
        console.log(res);
        if(res.code){
          this.formData.name = res.data
        }else if (res.code == undefined && res.data.code === 0){
          this.$message.warning(res.data.message)
        }
      })
    },
    handleShowPremission() {
      // 按钮权限显示
      if (this.permissions && this.permissions.indexOf('hide:filter:send') != '-1') {
        // 显示屏蔽发送按钮
        this.isPremissionShow = true;
      }
    },
    limitInput(event) {
      if (event.target.value == '0') {
        event.target.value = ''
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g, '')
      }
    },
    getSuffixList() {
      var type = '2'
      getPrecisionJdSuffixList(type).then(res => {
        if (res.code == "1") {
          this.suffixList = res.data;
          if (!this.formData.jdSmsSuffix) {
            this.formData.jdSmsSuffix = this.suffixList[0] || "";
          }
        }
      })
    },
    handleClose() {
      this.viewVisible = false;
    },
    isRepeat(arr) {
      var hash = {};
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    },
    // 提交
    handleConfirm() {
      // 节点名称
      if(!this.formData.name){
        return this.$message.error("节点名称不能为空")
      }
      if(!this.mediaTemplateId){
        return this.$message.error("卡片短信模板不能为空")
      }
      if(this.formData.filterAlreadySentFlag && !this.formData.filterDays){
        return this.$message.error("屏蔽已发送客户天数不能为空")
      }
      if(this.formData.sendIntType == 1 && !this.formData.smsLimit){
        return this.$message.error("限制发送数不能为空")
      }
      console.log(this.formData);
      // if (this.isRepeat(this.formData.content.match(/3\.cn/g))) {
      //   this.$message.warning("官方插入的短链接不允许超过1个哦！");
      //   return;
      // }
      var param = JSON.parse(JSON.stringify(this.formData))
      this.updateLoading = true;
      if(param.sendIntType==0){
        param.smsLimit = ''
      }
      param.mediaTemplateId = this.mediaTemplateId
      let content = this.failBackConfig.content
      if(this.failBackConfig.failBackType == 1 && !content.includes('拒收请回复R')){
        content = content + this.TTip
      }
      param.intelligentMarketingNodeSmsRole = {
        failBackConfig:{
          ...this.failBackConfig,
          content
        }
      }
      // 测试手机号
      if(this.mediaTestMobilesList && this.mediaTestMobilesList.length){
        param.mediaTestMobiles = this.mediaTestMobilesList.join(',')
      }
      mnode.updateCardDetail(param).then((res) => {
        this.updateLoading = false;
        if (res.code === 1) {
          this.$message.success("保存成功！");
          this.viewVisible = false;
          this.$emit('change-name', param)
        } else {
          this.$message.error(res.message)
        }
      });
    },
    // 富信测试手机号 
    selectMediaTestMobiles(val) {
      this.formData.mediaTestMobiles = this.mediaTestMobilesList.join(',')
    },
    // 关闭短信内容弹窗
    handleCloseSmsInfo() {
      this.smsInfoShow = false
    },
    changeFailMedia(){
      let row = this.mediaOptionList.find(o=>o.mediaTemplateId == this.failBackConfig.mediaTemplateId)
      getSmsMediaTemplateDetail(row.id).then(res=>{
        let data = res.data
        this.failBackConfig.content = data.text
        this.failBackConfig.jdShortLink = data.jdShortLink
        this.failBackConfig.realUrl = data.originUrl
        this.failBackConfig.mediaMulitiFileId = data.mediaMulitiFileId
      })
    },
    // 修改测试手机号弹窗
    updataPhone() {
      this.showDialogOne = true
    },
    // 修改测试手机号确认弹窗
    mobilPhoneSubmit() {
      updateSuffixMobileById({
        smsTestMobiles: this.testMobiles,
        id: this.textPhoneId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.mediaTestMobilesList = [];
            this.getValidSmsTestMobiles();
            this.showDialogOne = false
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => { });
    },
    // 切换签名
    switchSuffix(index) {
      this.selectSuffix = this.suffixList[index];
      this.formData.jdSmsSuffix = this.selectSuffix || "";
    },
    smsDialogClose(data) {
      // console.log(data, 111);
      this.smsDialogs = data;
    },
    transferName() {
      this.smsDialogs = false;
    },
    replaceSignature() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },
    toBlack() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
  
<style scoped lang="scss">
::v-deep .el-dialog__wrapper{
  background: rgba(0,0,0,0.5);
}
.xiao_hug2 {
  position: absolute;
  top: 50px;
  left: 755px;
  .mobile-box {
      position: relative;
      width: 256px;
      margin-top: 21px;
      height: 504px;

      // background: url("../../assets/images/mobileScreen.png") no-repeat;
      .message-content {
        position: absolute;
        word-wrap: break-word;
        max-height: 250px;
        overflow-y: auto;
        padding: 12px 12px;
        border-radius: 6px;
        width: 210px;
        font-size: 14px;
        background-color: #fafafa;
        line-height: 20px;
        left: 50%;
        margin-left: -104.665px;
        text-align: left;
        top: 25.4%;
      }
  }
  .mobile-tips {
    margin-top: 16px;
    font-size: 16px;
    text-align: center;
  }
}

.notShow {
  position: relative;

  img {
    margin-left: 100px;
    width: 348px;
    height: 348px;
  }

  p {
    position: absolute;
    left: 197px;
    top: 328px;
    color: #999999;
    font-size: 14px;
  }

  .bottom-btn {
    width: 560px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .select {
  width: 98px;
  height: 32px;
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  border-radius: 3px;
  background-color: #fff4f4;

  &:hover {
    color: #fe4d45;
    background-color: #ffe5e5;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.keep {
  width: 98px;
  height: 32px;
  margin: 0 10px 0 8px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
  border: 1px solid #fe4d45;
  background-color: #fe4d45;

  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
}
.btnListButtom {
    color: rgb(127, 133, 233);

    &:hover {
      color: #fe4d45;
    }
  }
.sms-content {
  position: relative;
}

.btnList {
  display: flex;
  align-items: center;
  height: 32px;

  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    cursor: pointer;
  }

  .btnListButtom {
    color: rgb(127, 133, 233);

    &:hover {
      color: #fe4d45;
    }
  }

  .btnBox {
    position: relative;
    overflow: hidden;
    height: 31px;
    margin-right: 16px;

    .btn {
      padding: 5px 12px;
      height: 31px;
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      cursor: pointer;
    }

    .check {
      position: absolute;
      right: -16px;
      bottom: -15px;
      width: 30px;
      height: 30px;
      background-color: #fe4d45;
      border-radius: 50%;
    }

    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }
}


.sms-box {
  width: 720px;
}


.dialog-footer-btn {
  text-align: center;
  // margin-top: 110px;
  padding-left: 280px;

  .search {
    width: 98px;
    height: 32px;
    color: #ffffff;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .reset {
    width: 98px;
    height: 32px;
    color: #666666;
    font-size: 14px;
    margin: 32px 0px 0 490px;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;

    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

.fx_btn {

  .select {
    width: 98px;
    height: 32px;
    cursor: pointer;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    border-radius: 3px;
    background-color: #fff4f4;

    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .keep {
    width: 98px;
    height: 32px;
    margin: 0 10px 0 8px;
    cursor: pointer;
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;

    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }

    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}

.selectBox1 {
  text-align: right;

  .headCnt {
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  button {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
}

.smsTest {
  .test {
    font-size: 14px;

    // height: 32px;
    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
      width: 98px;
      height: 32px;
      cursor: pointer;
    }

    .ipt {
      width: 224px;
      // margin: 0 0px 0 8px;
      vertical-align: top;
    }

    .sendTest {
      width: 106px;
      margin-left: 16px;
      padding: 5px 12px;
      border: 1px solid #fe4d45;
      background-color: #fff;
      color: #fe4d45;

      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45 !important;
      }

      &:active {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }

    .record {
      margin: 0 24px 0 8px;
      color: #333333;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #cccccc;
      background-color: #fff;

      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }

    .record1 {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
      font-size: 14px;
      border-radius: 3px;
      width: 114px;
    }
  }

  .info {
    width: 600px;
    margin-top: 12px;
    line-height: 22px;
    font-size: 13px;
    color: #999;
    background: #FFFAEE;
    padding: 12px;
    color: #333;
    position: relative;

    p {
      margin: 0px;
      line-height: 25px;
      padding-left: 18px;
    }

    .warning-icon {
      color: #ffb95e;
      font-size: 16px;
      position: absolute;
      left: 10px;
      top: 18px;
    }
  }
}



.dialog-wrapper {
  .item {
    margin: 8px 0;

    .item-title {
      width: 200px;
    }

    .input {
      display: inline-block;
      vertical-align: middle;
      width: 330px;
    }
  }

  .remarks {
    // margin-top: 20px;
    width: 400px;
    // height: 44px;
    background: #fafafa;
    opacity: 1;
    line-height: 20px;
  }

  .remarksOne {
    padding: 10px;
    margin-top: 20px;
    width: 400px;
    // height: 80px;
    background: #fafafa;
    opacity: 1;

    // line-height: 44px;
    .boxText {
      // float: left;
      margin: -14px 0 0 20px;
    }

    .icon_i {
      display: inline-block;
      // position: absolute;
      width: 14px;
      height: 14px;
      border-radius: 14px;
      background-color: #ffb95e;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      line-height: 14px;
      font-weight: bold;
      // top: 3px;
      // left: 10px;
    }
  }
}

.message-zindex {
  z-index: 99999 !important;
}
.setName{
 position: absolute;
 right:45px;
 top:0px;
 color: #a585ea;
 cursor: pointer;
 &:hover{
   color: #fe4d45;
 }
}

::v-deep .textareaChange .el-textarea__inner {
  border: 1px solid #dcdfe6 !important;

  &:focus {
    border: 1px solid #fe4d45 !important;
  }
}
.textarea {
      box-sizing: border-box;
      padding: 6px 6px 10px;
      width: 100%;
      background: rgba(249, 250, 251, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 2px;

      .footInfo {
        display: flex;
        justify-content: space-between;
        margin-top: 9px;
        font-size: 14px;
        color: #333;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 76px;
          height: 28px;
          outline: none;
          border: none;
          background-color: white;
          border-radius: 2px;
          font-size: 14px;
        }

        div {
          display: flex;
          align-items: center;
        }

        .select {
          // margin: 0 10px 0 8px;
          width: 76px;
          height: 28px;
          opacity: 1;
          border-radius: 3px;
          font-size: 13px;
          margin-right: 8px;
          cursor: pointer;
          border: 1px solid #fe4d45;
          color: #fe4d45;
          background-color: #fff4f4;

          &:hover {
            color: #fe4d45;
            background-color: #ffe5e5;
          }
        }

        .question_icon {
          width: 14px;
          height: 14px;
          color: #7f85e9 !important;
          display: inline-block;
          line-height: 12px !important;
          text-align: center;
          border-radius: 14px;
          border: 1px solid #7f85e9;
          font-size: 12px !important;
          font-weight: normal !important;
          margin-left: 8px;

          &:hover {
            color: #fe4d45 !important;
            border: 1px solid #fe4d45;
          }
        }

        .keep {
          // margin: 0 10px 0 8px;
          width: 76px;
          height: 28px;
          border-radius: 3px;
          font-size: 13px;
          /* font-family: PingFang SC; */
          font-weight: 400;
          margin-right: 8px;
          cursor: pointer;
          color: #ffffff;
          background-color: #fe4d45;

          &:hover {
            color: #fff;
            opacity: 0.9;
            background-color: #fe4d45;
          }
        }
      }

      // .ask-content {
      //   position: relative;
      //   display: inline-block;
      //   vertical-align: middle;
      //   cursor: pointer;
      //   .ask-icon {
      //     display: inline-block;
      //     vertical-align: middle;
      //     cursor: pointer;
      //     position: relative;
      //   }

      // .ask-icon-select {
      //   position: absolute;
      //   bottom: -143px;
      //   margin-left: -158px;
      //   display: none;
      //   width: 375px;
      //   // height: 80px;

      //   line-height: 20px;
      //   padding: 20px;
      //   background-color: #fff;
      //   text-align: left;
      //   box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
      //   color: #999999;
      // }
      // .ask-icon-select:before {
      //   position: absolute;
      //   content: "";
      //   width: 0;
      //   height: 0;
      //   right: 50%;
      //   margin-left: -4px;
      //   bottom: 100%;
      //   border-left: 8px solid transparent;
      //   border-top: 8px solid #fff;
      //   border-right: 8px solid transparent;
      // }
      // }
      // .ask-content:hover {
      //   .ask-icon-select {
      //     display: block;
      //   }
      // }
    }

    .footTips {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-top: 8px;
      padding-left: 12px;
      height: 28px;
      background: rgba(255, 250, 238, 1);
      border: 1px solid rgba(255, 185, 94, 1);
      border-radius: 2px;
      color: #333;
      font-size: 14px;
    }

    .tool {
      display: flex;
      align-items: center;
      height: 32px;

      p {
        box-sizing: border-box;
        padding: 0 8px;
        margin: 0 8px 0 0;
        font-size: 14px;
        border-radius: 3px;
        background-color: #f7f8fe;
        border: 1px solid #7f85e9;
        color: #7f85e9;

        &:hover {
          background: rgba(174, 179, 241, 0.16);
          border: 1px solid #7f85e9 !important;
          color: #7f85e9 !important;
        }

        &:active {
          background: rgba(174, 179, 241, 0.24);
          border: 1px solid #7f85e9 !important;
          color: #7f85e9;
        }
      }
    }
    .question_icon {
      width: 14px;
      height: 14px;
      color: #7f85e9 !important;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #7f85e9;
      font-size: 12px !important;
      font-weight: normal !important;
      cursor: pointer;
      &:hover {
        color: #fe4d45 !important;
        border: 1px solid #fe4d45;
      }
    }
    .selectBox {
    text-align: right;

    .headCnt {
      display: flex;
      align-items: center;
      margin-top: 20px;
    }

    .keepBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-top: 20px;
      text-align: center;
      background: rgba(254, 77, 69, 1);
      border-radius: 3px;
      color: #fff;
      font-size: 14px;
    }

    button {
      border: none;
      background-color: white;
      outline: none;
      padding: 0;
      margin: 0;
      border-radius: 2px;
    }
  }
  .name-wrap{
    display: flex;
    align-items: center;
    white-space: nowrap;
    &-input{
      width: 346px;
      /deep/.el-input__inner{
        padding-right: 50px!important;
      }
    }
    &-setName{
      color: #7f85e9;
      cursor: pointer;
      margin-left: 8px;
    }
  }
</style>